import { useEffect, useState } from "react";

const TABLET_QUERY = "(max-width: 1331px)";

export function useIsTabletLayout(): boolean {
  const [isTablet, setIsTablet] = useState(
    () => typeof window !== "undefined" && window.matchMedia(TABLET_QUERY).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(TABLET_QUERY);
    const onChange = (e: MediaQueryListEvent) => setIsTablet(e.matches);
    mql.addEventListener("change", onChange);
    setIsTablet(mql.matches);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isTablet;
}
